import { canActivateAdminRoute } from './guard/auth.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'auth/call', loadChildren: () => import('./pages/auth/auth/auth.module').then(m=>m.AuthPageModule) },
  { path: 'auth/sms', loadChildren: () => import('./pages/auth/auth-sms/auth-sms.module').then(m=>m.AuthSmsPageModule) },
  { path: 'auth', redirectTo: 'auth/call', pathMatch: 'full' },
  { path: 'admin/reserves', loadChildren: () => import('./pages/admin/reserves-by-phone/reserves-by-phone.module').then(m => m.ReservesByPhoneModule) },
  { path: 'admin/reserve/:id', loadChildren: () => import('./pages/admin/reserve/reserve.module').then(m=>m.ReservePageModule), canActivate:[canActivateAdminRoute],data:{super:false}},
  { path: 'admin/masters', loadChildren: () => import('./pages/admin/masters/masters.module').then(m=>m.MastersPageModule), canActivate:[canActivateAdminRoute],data:{super:true}},
  { path: 'admin/services', loadChildren: () => import('./pages/admin/services/services.module').then(m=>m.ServicesPageModule), canActivate:[canActivateAdminRoute],data:{super:true}},
  { path: 'admin/media/:type/:id', loadChildren: () => import('./pages/admin/media/media.module').then(m=>m.MediaPageModule), canActivate:[canActivateAdminRoute],data:{super:true}},
  { path: 'admin/contacts-edit', loadChildren: () => import('./pages/admin/contacts-edit/contacts-edit.module').then(m=>m.ContactsEditPageModule), canActivate:[canActivateAdminRoute],data:{super:true}},
  { path: 'wpd', loadChildren: () => import('./pages/admin/web-push-diagnostic/web-push-diagnostic.module').then(m => m.WebPushDiagnosticModule),canActivate:[canActivateAdminRoute],data:{super:false} },
  { path: 'privacy', loadChildren: () => import('./pages/privacy/privacy.module').then(m=>m.PrivacyPageModule) },
  { path: 'test', loadChildren: () => import('./test-page/test-page.module').then(m => m.TestPageModule) },
  { path: '', loadChildren: () => import('./tabs/tabs.module').then(m=>m.TabsPageModule) },


  // { path:'**', redirectTo:'',pathMatch:'full'}
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {

    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
